"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "toggledPresenterLive", {
  enumerable: true,
  get: function get() {
    return _toggledPresenterLive["default"];
  }
});
var _toggledPresenterLive = _interopRequireDefault(require("./toggledPresenterLive"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }